/**
 * FlashcardSkeleton component displays loading placeholders.
 * Shows multiple skeleton cards during initial data load.
 *
 * @param {Object} props - Component props
 * @param {number} [props.count=3] - Number of skeleton items to show
 * @returns {React.ReactElement} Flashcard skeleton loader
 */
export default function FlashcardSkeleton({ count = 3 }) {
  return (
    <div className="flashcard-skeleton" aria-label="Ładowanie fiszek...">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="flashcard-skeleton__item">
          <div className="flashcard-skeleton__question"></div>
          <div className="flashcard-skeleton__line"></div>
        </div>
      ))}
    </div>
  )
}
